import React from 'react';
import { Box, Button, Grid, Typography, Select, MenuItem } from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
    onBoardingDesignStyle : {
        height:'100vh',
        padding:'40px 48px'
    },
    logoStyle: {
        width: '220px',
        height: '49.18px',
        objectFit:'contain',
        [theme.breakpoints.down(1400)] : {
            width: '190px',
            height: '40px',
        }
    },
    headingContainer: {
        marginTop:'64px'
    },
    headingTextStyle: {
        fontSize:'27px',
        fontWeight: '600',
        color:'#fff',
        lineHeight:'31px',
        [theme.breakpoints.down(1400)] : {
            fontSize:'21px'
        }
    },
    paragraphTextStyle: {
        marginTop:'16px',
        color:'#fff',
        fontSize:'15px',
    },
    imageContainer : {
        marginTop:'72px',
        [theme.breakpoints.down(1400)] : {
            marginTop:'52px'
        }
    },
    onboardHeading: {
        fontSize : "19px",
        fontWeight: "600",
        margin:'0px auto 8px auto',
    },
    imageStyle: {
        marginLeft:'16px',
        [theme.breakpoints.down(1400)] : {
            width:'75%'
        }
    },
}));


const LeftDesignComponent = ({appTitleAndSubtitle, isAppDomainTyno  }) => {
    const classes = useStyles();

    return (
        <Grid size={{md: 4}} className={classes.onBoardingDesignStyle}
            style={{
                background: isAppDomainTyno ? 'linear-gradient(90deg, #367649 0%, #182D2F 100%)' : '#3d3d3d',
            }}
            >
            <Grid container direction='column'>
                <Grid size={{md: 12}}>
                    <img src={isAppDomainTyno ? '/images/tyno-horizontal-logo-white.png' : '/images/eProcessify_logo_name_white.png'}
                        className={classes.logoStyle}
                        style={{ marginLeft: isAppDomainTyno ? '-32px' : '0px'}}
                        alt='Logo'
                        />
                </Grid>

                <Grid size={{md: 12}} className={classes.headingContainer}>
                    <Typography className={classes.headingTextStyle}>
                        {appTitleAndSubtitle?.title}
                    </Typography>

                    <Typography className={classes.paragraphTextStyle}>
                        {appTitleAndSubtitle?.subtitle}
                    </Typography>
                </Grid>

                <Grid size={{md: 12}} className={classes.imageContainer}>
                    <img src='/images/on_borboarding_image.svg' className={classes.imageStyle}/>
                </Grid>
            </Grid>
        </Grid>
    );
}

export default LeftDesignComponent;